import * as React from 'react'

interface IProps {
  siteName: string
}

interface IState {
  isIE10: boolean
}

export default class OldIE extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      isIE10: false
    }
  }

  public componentDidMount() {
    const isIE10 = /MSIE 10/.test(navigator.userAgent)
    this.setState({
      isIE10
    })
  }

  public render() {
    const { siteName } = this.props
    const { isIE10 } = this.state
    return (
      <div>
        {isIE10 && (
          <div
            dangerouslySetInnerHTML={{
              __html: this.renderIE10String(siteName)
            }}
          />
        )}
        <div
          dangerouslySetInnerHTML={{ __html: this.renderIE9String(siteName) }}
        />
      </div>
    )
  }

  private renderIE9String(siteName: string) {
    return `
        <!--[if lte IE 9]>
          <div class="alert-ie">
            ${siteName}.net no longer actively supports this version of Internet Explorer. We suggest that you <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">upgrade to a newer version</a> or <a href="http://browsehappy.com/">try a different browser</a>.
          </div>
        <![endif]-->
      `
  }

  private renderIE10String(siteName: string) {
    return `
        <div class="alert-ie">
          ${siteName}.net no longer actively supports this version of Internet Explorer. We suggest that you <a href="http://windows.microsoft.com/en-us/internet-explorer/download-ie">upgrade to a newer version</a> or <a href="http://browsehappy.com/">try a different browser</a>.
        </div>
      `
  }
}
